import { AxiosError } from 'axios';
import { useMutation, useQuery } from 'react-query';
import type {
  GetPatientSatisfactionSurveyResponse,
  PatientSatisfactionSurveyAction,
  SubmitPatientSatisfactionSurveyResponse,
} from '@aldebaran/common/types/api';
import { client } from '@/util/client';

export type PatientSatisfactionAction = PatientSatisfactionSurveyAction;

// consultationDate is a Date on the API side, a string once it crosses JSON.
export type PatientSatisfactionSurvey = Omit<
  GetPatientSatisfactionSurveyResponse,
  'consultationDate'
> & { consultationDate: string };

export const usePatientSatisfactionSurvey = (id: string) =>
  useQuery<PatientSatisfactionSurvey, AxiosError>(
    ['patientSatisfaction', id],
    async () =>
      client(`/patient-satisfaction/${id}`).then((response) => response.data),
    { enabled: !!id, retry: false },
  );

export const useSubmitPatientSatisfactionSurvey = (id: string) =>
  useMutation<
    SubmitPatientSatisfactionSurveyResponse,
    AxiosError,
    { rating: number; comment?: string }
  >(async ({ rating, comment }) =>
    client
      .post(`/patient-satisfaction/${id}/submit`, { rating, comment })
      .then((response) => response.data),
  );

export const useUnsubscribeFromSatisfactionSurveys = (id: string) =>
  useMutation<unknown, AxiosError, void>(async () =>
    client.post(`/patient-satisfaction/${id}/unsubscribe-satisfaction-surveys`),
  );

export const useUnsubscribeFromAllEmails = (id: string) =>
  useMutation<unknown, AxiosError, void>(async () =>
    client.post(`/patient-satisfaction/${id}/unsubscribe-all-emails`),
  );
